import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';

export const getUrl = (boardId: string) => `/rest/agile/1.0/board/${boardId}`;

export type Response = {
	id: string;
	location?: {
		userAccountId?: string;
	};
};

export const getBoard = async (boardId: string): Promise<Response> => {
	const url = getUrl(boardId);
	const response = await fetch(url, getDefaultOptions(url));

	if (!response.ok) {
		const text = await response.text();
		throw new FetchError(response.status, text);
	}

	return response.json();
};
